module.exports = __webpack_public_path__ + "img/choice.0d740b00.png";